import { render, staticRenderFns } from "./promtionCell.vue?vue&type=template&id=0672b5e6&scoped=true"
import script from "./promtionCell.vue?vue&type=script&lang=js"
export * from "./promtionCell.vue?vue&type=script&lang=js"
import style0 from "./promtionCell.vue?vue&type=style&index=0&id=0672b5e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672b5e6",
  null
  
)

export default component.exports